export enum MaterialType {
  Cement = 'Cement',
  Clinker = 'Clinker',
  IntermediateAndFinishedProducts = 'IntermediateAndFinishedProducts',
  RawMaterials = 'RawMaterials',
  Fuels = 'Fuels',
  EnhancersForCement = 'EnhancersForCement',
  AdditivesForClinker = 'AdditivesForClinker',
  NonReportedMaterials = 'NonReportedMaterials',
  OtherGroundProductsThanCement = 'OtherGroundProductsThanCement',
  OtherPyroProductsThanClinker = 'OtherPyroProductsThanClinker'
}

export enum MaterialSource {
  ProducedInPlant = 'ProducedInPlant',
  BoughtFromVendor = 'BoughtFromVendor',
  BoughtAndProduced = 'BoughtAndProduced'
}

export enum ProductType {
  PH5_PRODH = 'BI_PRODH__BI_PRDH5A',
  PH5_MATSLS = 'BI_MATSLS__BI_PRDH5A',
  PH6_PRODH = 'BI_PRODH__BI_PRDH6A',
  PH6_MATSLS = 'BI_MATSLS__BI_PRDH6A',
  MARERIAL_SAP = 'BI_MATERL_MM_STOCK',
  MATERIAL_SD = 'BI_MATERL',
  MATERIAL_MM = 'BI_MATERL_MM'
}

export enum ProductForecastStatus {
  Requested = 'Requested',
  Success = 'Success'
}

export enum MaterialSettingsTabs {
  General = 'general',
  Classification = 'classification',
  SapCodes = 'sapCodes',
  LimsCodes = 'limsCodes',
  Recipes = 'recipes',
  PxTrendTags = 'pxTrendTags',
  Targets = 'targets'
}

// TODO <HCP-82759>: remove after all add/edit material tabs functionalities
// are moved to the single save button
export enum MaterialApiKeys {
  globalMaterial = 'global-material'
}

// All classification input names
enum ClassificationInputNames {
  Selection = 'selection',
  Standard = 'standard',
  Const1 = 'const1',
  Const2 = 'const2',
  Strength1 = 'strength1',
  Strength2 = 'strength2',
  SulphurLevel = 'sulphurLevel',
  HeatOfHydration = 'heatOfHydration',
  LowAlkali = 'lowAlkali',
  SpecialCharacteristics = 'specialCharacteristics',
  CategoryForAnnualReport = 'categoryForAnnualReport',
  IntermediateMillProduct = 'intermediateMillProduct',
  MethodOfFinenessDetermination = 'methodOfFinenessDetermination',
  ReferenceMeshSizeForResidue = 'referenceMeshSizeForResidue',
  AlkaliContent = 'alkaliContent',
  Grade = 'grade',
  LowHeat = 'lowHeat',
  IsThermallyProcessedClinkerSubstitute = 'isThermallyProcessedClinkerSubstitute',
  RawMaterialCategory = 'rawMaterialCategory',
  RawMaterialSubCategory = 'rawMaterialSubCategory',
  RawMaterialType = 'rawMaterialType',
  FuelType = 'fuelType',
  FuelCategory = 'fuelCategory',
  FuelSubCategory = 'fuelSubCategory',
  SubCategory = 'subCategory',
  Brand = 'brand',
  OtherBrand = 'otherBrand',
  Category = 'category',
  Type = 'type',
  SulphateResistance = 'sulphateResistance',
  FormSize = 'formSize',
  ProcessingDegree = 'processingDegree',
  UsedForCement = 'usedForCement',
  UsedForClinker = 'usedForClinker',
  LegacyId = 'legacyId'
}

export const CementClassificationInputNames = {
  Standard: ClassificationInputNames.Standard,
  Type: ClassificationInputNames.Type,
  Const1: ClassificationInputNames.Const1,
  Const2: ClassificationInputNames.Const2,
  Strength1: ClassificationInputNames.Strength1,
  Strength2: ClassificationInputNames.Strength2,
  SulphateResistance: ClassificationInputNames.SulphateResistance,
  SulphurLevel: ClassificationInputNames.SulphurLevel,
  HeatOfHydration: ClassificationInputNames.HeatOfHydration,
  LowAlkali: ClassificationInputNames.LowAlkali,
  SpecialCharacteristics: ClassificationInputNames.SpecialCharacteristics,
  CategoryForAnnualReport: ClassificationInputNames.CategoryForAnnualReport,
  IntermediateMillProduct: ClassificationInputNames.IntermediateMillProduct,
  ReferenceMeshSizeForResidue: ClassificationInputNames.ReferenceMeshSizeForResidue,
  LegacyId: ClassificationInputNames.LegacyId
} as const

export type CementClassificationInputNames =
  (typeof CementClassificationInputNames)[keyof typeof CementClassificationInputNames]

export const ClinkerClassificationInputNames = {
  AlkaliContent: ClassificationInputNames.AlkaliContent,
  Grade: ClassificationInputNames.Grade,
  LowHeat: ClassificationInputNames.LowHeat,
  SulphateResistance: ClassificationInputNames.SulphateResistance,
  Type: ClassificationInputNames.Type,
  LegacyId: ClassificationInputNames.LegacyId
} as const

export type ClinkerClassificationInputNames =
  (typeof ClinkerClassificationInputNames)[keyof typeof ClinkerClassificationInputNames]

export const RawMaterialsClassificationInputNames = {
  Category: ClassificationInputNames.Category,
  IsThermallyProcessedClinkerSubstitute:
    ClassificationInputNames.IsThermallyProcessedClinkerSubstitute,
  RawMaterialCategory: ClassificationInputNames.RawMaterialCategory,
  RawMaterialSubCategory: ClassificationInputNames.RawMaterialSubCategory,
  RawMaterialType: ClassificationInputNames.RawMaterialType,
  FormSize: ClassificationInputNames.FormSize,
  ProcessingDegree: ClassificationInputNames.ProcessingDegree,
  UsedForCement: ClassificationInputNames.UsedForCement,
  UsedForClinker: ClassificationInputNames.UsedForClinker,
  LegacyId: ClassificationInputNames.LegacyId
} as const

export type RawMaterialsClassificationInputNames =
  (typeof RawMaterialsClassificationInputNames)[keyof typeof RawMaterialsClassificationInputNames]

export const FuelsClassificationInputNames = {
  FuelType: ClassificationInputNames.FuelType,
  FuelCategory: ClassificationInputNames.FuelCategory,
  FuelSubCategory: ClassificationInputNames.FuelSubCategory,
  FormSize: ClassificationInputNames.FormSize,
  ProcessingDegree: ClassificationInputNames.ProcessingDegree,
  LegacyId: ClassificationInputNames.LegacyId
} as const

export type FuelsClassificationInputNames =
  (typeof FuelsClassificationInputNames)[keyof typeof FuelsClassificationInputNames]

export const EnhancersForCementClassificationInputNames = {
  Category: ClassificationInputNames.Category,
  SubCategory: ClassificationInputNames.SubCategory,
  Brand: ClassificationInputNames.Brand,
  OtherBrand: ClassificationInputNames.OtherBrand,
  LegacyId: ClassificationInputNames.LegacyId
} as const

export type EnhancersForCementClassificationInputNames =
  (typeof EnhancersForCementClassificationInputNames)[keyof typeof EnhancersForCementClassificationInputNames]

export const AdditivesForClinkerClassificationInputNames = {
  Category: ClassificationInputNames.Category,
  LegacyId: ClassificationInputNames.LegacyId
} as const

export type AdditivesForClinkerClassificationInputNames =
  (typeof AdditivesForClinkerClassificationInputNames)[keyof typeof AdditivesForClinkerClassificationInputNames]

export const IntermediateAndFinishedProductsClassificationInputNames = {
  Category: ClassificationInputNames.Category,
  IntermediateMillProduct: ClassificationInputNames.IntermediateMillProduct,
  MethodOfFinenessDetermination: ClassificationInputNames.MethodOfFinenessDetermination,
  ReferenceMeshSizeForResidue: ClassificationInputNames.ReferenceMeshSizeForResidue,
  Selection: ClassificationInputNames.Selection,
  LegacyId: ClassificationInputNames.LegacyId
} as const

export type IntermediateAndFinishedProductsClassificationInputNames =
  (typeof IntermediateAndFinishedProductsClassificationInputNames)[keyof typeof IntermediateAndFinishedProductsClassificationInputNames]

export const OtherGroundProductsThanCementClassificationInputNames = {
  Category: ClassificationInputNames.Category,
  IntermediateMillProduct: ClassificationInputNames.IntermediateMillProduct,
  ReferenceMeshSizeForResidue: ClassificationInputNames.ReferenceMeshSizeForResidue,
  LegacyId: ClassificationInputNames.LegacyId
} as const

export type OtherGroundProductsThanCementClassificationInputNames =
  (typeof OtherGroundProductsThanCementClassificationInputNames)[keyof typeof OtherGroundProductsThanCementClassificationInputNames]

export const OtherPyroProductsThanClinkerClassificationInputNames = {
  Category: ClassificationInputNames.Category,
  LegacyId: ClassificationInputNames.LegacyId
} as const
export type OtherPyroProductsThanClinkerClassificationInputNames =
  (typeof OtherPyroProductsThanClinkerClassificationInputNames)[keyof typeof OtherPyroProductsThanClinkerClassificationInputNames]
